<div>
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button
        class="nav-link active"
        id="pending-tab"
        data-toggle="tab"
        data-target="#pending"
        type="button"
        role="tab"
        aria-controls="pending"
        aria-selected="true"
        (click)="incubatorCheck('0')"
      >
        Pending
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button
        class="nav-link"
        id="approval-tab"
        data-toggle="tab"
        data-target="#approval"
        type="button"
        role="tab"
        aria-controls="approval"
        aria-selected="false"
        (click)="incubatorCheck('1')"
      >
        Approved
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button
        class="nav-link"
        id="rejected-tab"
        data-toggle="tab"
        data-target="#rejected"
        type="button"
        role="tab"
        aria-controls="rejected"
        aria-selected="false"
        (click)="incubatorCheck('-1')"
      >
        Rejected
      </button>
    </li>
  </ul>
  <div class="tab-content" id="myTabContent">
    <div
      class="tab-pane fade show active"
      id="pending"
      role="tabpanel"
      aria-labelledby="pending-tab"
    >
      <div *ngIf="noData == false">
        <div class="download-div">
          <button
            mat-raised-button
            color="accent"
            (click)="downloadExcel('Pending', 0)"
          >
            Export <i class="far fa-file-excel"></i>
          </button>
        </div>
        <div class="table-responsives">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns; let i = index"
            ></tr>
            <ng-container matColumnDef="index" class="text-center">
              <th mat-header-cell *matHeaderCellDef>No</th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorName">
              <th mat-header-cell *matHeaderCellDef>Incubator Name</th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.incubatorName.length <= 20">
                  {{ element.incubatorName }}
                </span>
                <span *ngIf="element.incubatorName.length > 20">
                  <span *ngIf="!expandedRow[element.incubatorName]">
                    {{ element.incubatorName | slice : 0 : 20 }}...
                    <a
                      href="javascript:void(0)"
                      (click)="toggleReadMore(element.incubatorName)"
                      >Read More</a
                    >
                  </span>
                  <span *ngIf="expandedRow[element.incubatorName]">
                    {{ element.incubatorName }}
                    <a
                      href="javascript:void(0)"
                      (click)="toggleReadMore(element.incubatorName)"
                      >Read Less</a
                    >
                  </span>
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorEmail">
              <th mat-header-cell *matHeaderCellDef>Incubator Email Id</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorEmail }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorPhone">
              <th mat-header-cell *matHeaderCellDef>Incubator Phone Number</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorPhone }}
              </td>
            </ng-container>
            <ng-container matColumnDef="uniqueId">
              <th
                mat-header-cell
                *matHeaderCellDef
                [ngClass]="{ 'd-none': status == '0' }"
              >
                Incubator ID
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="center-cell"
                [ngClass]="{ 'd-none': status == '0' }"
              >
                <span>{{ element.uniqueId ? element.uniqueId : "-" }} </span>
                <span *ngIf="element.uniqueId === 'Other'"
                  >- {{ element.uniqueId }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegDesc">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Description
              </th>
              <td mat-cell *matCellDef="let element" class="text-center c-blue">
                <ng-container *ngIf="element.incubatorRegDesc">
                  <ion-icon
                    name="eye-outline"
                    (click)="
                      viewDescrptionBtn(
                        element.incubatorRegDesc,
                        'Description Details'
                      )
                    "
                  ></ion-icon>
                </ng-container>
                <ng-container class="c-black" *ngIf="!element.incubatorRegDesc">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorStatusUpdatedDate">
              <th mat-header-cell *matHeaderCellDef>Registered Date</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorStatusUpdatedDate }}
              </td>
            </ng-container>
            <ng-container matColumnDef="reason">
              <th
                [ngClass]="{ 'd-none': status != '-1' }"
                mat-header-cell
                *matHeaderCellDef
              >
                Reason
              </th>
              <td
                [ngClass]="{ 'd-none': status != '-1' }"
                mat-cell
                *matCellDef="let element"
              >
                {{ element.reason }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegistrationType">
              <th mat-header-cell *matHeaderCellDef>Registration Type</th>
              <td mat-cell *matCellDef="let element" class="center-cell">
                <span
                  >{{
                    element.incubatorRegistrationType
                      ? element.incubatorRegistrationType
                      : "-"
                  }}
                </span>
                <span *ngIf="element.incubatorRegistrationType === 'Other'"
                  >- {{ element.incubatorRegistrationTypeOther }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegFileName">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Document
              </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <ng-container *ngIf="element.incubatorRegFileName">
                  <a href="{{ element.incubatorRegFileName }}" target="_blank">
                    <ion-icon name="document-attach-outline"></ion-icon>
                  </a>
                </ng-container>
                <ng-container *ngIf="!element.incubatorRegFileName">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                Action
              </th>
              <td class="text-center" mat-cell *matCellDef="let element">
                <button
                  class="approval-spanss"
                  (click)="modalOpen(element.incubatorUserId)"
                >
                  Approve
                </button>
                <button
                  class="reject-span"
                  (click)="rejectReason(element.incubatorUserId)"
                >
                  Reject
                </button>
              </td>
            </ng-container>
          </table>
        </div>
        <mat-paginator
          #paginator
          class="mat-elevation-z8"
          [length]="pageTotalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[25, 50, 75, 100]"
          showFirstLastButtons
          (page)="getServerData($event)"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>There are no incubators pending for approval</h6>
      </div>
    </div>
    <div
      class="tab-pane fade"
      id="approval"
      role="tabpanel"
      aria-labelledby="approval-tab"
    >
      <div *ngIf="noData == false">
        <div class="download-div">
          <button
            mat-raised-button
            color="accent"
            (click)="downloadExcel('Approval', 1)"
          >
            Export <i class="far fa-file-excel"></i>
          </button>
        </div>
        <div class="table-responsives">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns; let i = index"
            ></tr>
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef>No</th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorName">
              <th mat-header-cell *matHeaderCellDef>Incubator Name</th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.incubatorName.length <= 20">
                  {{ element.incubatorName }}
                </span>
                <span *ngIf="element.incubatorName.length > 20">
                  <span *ngIf="!expandedRow[element.incubatorName]">
                    {{ element.incubatorName | slice : 0 : 20 }}...
                    <a
                      href="javascript:void(0)"
                      (click)="toggleReadMore(element.incubatorName)"
                      >Read More</a
                    >
                  </span>
                  <span *ngIf="expandedRow[element.incubatorName]">
                    {{ element.incubatorName }}
                    <a
                      href="javascript:void(0)"
                      (click)="toggleReadMore(element.incubatorName)"
                      >Read Less</a
                    >
                  </span>
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="incubatorEmail">
              <th mat-header-cell *matHeaderCellDef>Incubator Email Id</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorEmail }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorPhone">
              <th mat-header-cell *matHeaderCellDef>Incubator Phone Number</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorPhone }}
              </td>
            </ng-container>
            <ng-container matColumnDef="uniqueId">
              <th mat-header-cell *matHeaderCellDef>Incubator ID</th>
              <td mat-cell *matCellDef="let element">
                <span>{{ element.uniqueId ? element.uniqueId : "-" }} </span>
                <span *ngIf="element.uniqueId === 'Other'"
                  >- {{ element.uniqueId }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegDesc">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Description
              </th>
              <td mat-cell *matCellDef="let element" class="text-center c-blue">
                <ng-container *ngIf="element.incubatorRegDesc">
                  <ion-icon
                    name="eye-outline"
                    (click)="
                      viewDescrptionBtn(
                        element.incubatorRegDesc,
                        'Description Details'
                      )
                    "
                  ></ion-icon>
                </ng-container>
                <ng-container class="c-black" *ngIf="!element.incubatorRegDesc">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorStatusUpdatedDate">
              <th mat-header-cell *matHeaderCellDef>Approved Date</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorStatusUpdatedDate }}
              </td>
            </ng-container>
            <ng-container matColumnDef="reason">
              <th
                [ngClass]="{ 'd-none': status != '-1' }"
                mat-header-cell
                *matHeaderCellDef
              >
                Reason
              </th>
              <td
                [ngClass]="{ 'd-none': status != '-1' }"
                mat-cell
                *matCellDef="let element"
              >
                {{ element.reason }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegistrationType">
              <th mat-header-cell *matHeaderCellDef>Registration Type</th>
              <td mat-cell *matCellDef="let element">
                <span
                  >{{
                    element.incubatorRegistrationType
                      ? element.incubatorRegistrationType
                      : "-"
                  }}
                </span>
                <span *ngIf="element.incubatorRegistrationType === 'Other'"
                  >- {{ element.incubatorRegistrationTypeOther }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegFileName">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Document
              </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <ng-container *ngIf="element.incubatorRegFileName">
                  <a href="{{ element.incubatorRegFileName }}" target="_blank">
                    <ion-icon name="document-attach-outline"></ion-icon>
                  </a>
                </ng-container>
                <ng-container *ngIf="!element.incubatorRegFileName">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                Action
              </th>
              <td class="text-center" mat-cell *matCellDef="let element">
                <button
                  class="approval-span"
                  (click)="pendingModalOpen(element.incubatorUserId)"
                >
                  Move to Pending
                </button>
                <button
                  class="reject-span"
                  (click)="rejectReason(element.incubatorUserId)"
                >
                  Reject
                </button>
              </td>
            </ng-container>
          </table>
        </div>
        <mat-paginator
          #paginator
          class="mat-elevation-z8"
          [length]="pageTotalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[25, 50, 75, 100]"
          showFirstLastButtons
          (page)="getServerData($event)"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>There are no approved incubators</h6>
      </div>
    </div>
    <div
      class="tab-pane fade"
      id="rejected"
      role="tabpanel"
      aria-labelledby="rejected-tab"
    >
      <div *ngIf="noData == false">
        <div class="download-div">
          <button
            mat-raised-button
            color="accent"
            (click)="downloadExcel('Rejected', -1)"
          >
            Export <i class="far fa-file-excel"></i>
          </button>
        </div>
        <div class="table-responsives">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns; let i = index"
            ></tr>
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef>No</th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorName">
              <th mat-header-cell *matHeaderCellDef>Incubator Name</th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.incubatorName.length <= 20">
                  {{ element.incubatorName }}
                </span>
                <span *ngIf="element.incubatorName.length > 20">
                  <span *ngIf="!expandedRow[element.incubatorName]">
                    {{ element.incubatorName | slice : 0 : 20 }}...
                    <a
                      href="javascript:void(0)"
                      (click)="toggleReadMore(element.incubatorName)"
                      >Read More</a
                    >
                  </span>
                  <span *ngIf="expandedRow[element.incubatorName]">
                    {{ element.incubatorName }}
                    <a
                      href="javascript:void(0)"
                      (click)="toggleReadMore(element.incubatorName)"
                      >Read Less</a
                    >
                  </span>
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorEmail">
              <th mat-header-cell *matHeaderCellDef>Incubator Email Id</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorEmail }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorPhone">
              <th mat-header-cell *matHeaderCellDef>Incubator Phone Number</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorPhone }}
              </td>
            </ng-container>
            <ng-container matColumnDef="uniqueId">
              <th
                mat-header-cell
                *matHeaderCellDef
                [ngClass]="{ 'd-none': status == '-1' }"
              >
                Incubator ID
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="center-cell"
                [ngClass]="{ 'd-none': status == '-1' }"
              >
                <span>{{ element.uniqueId ? element.uniqueId : "-" }} </span>
                <span *ngIf="element.uniqueId === 'Other'"
                  >- {{ element.uniqueId }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegDesc">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Description
              </th>
              <td mat-cell *matCellDef="let element" class="text-center c-blue">
                <ng-container *ngIf="element.incubatorRegDesc">
                  <ion-icon
                    name="eye-outline"
                    (click)="
                      viewDescrptionBtn(
                        element.incubatorRegDesc,
                        'Description Details'
                      )
                    "
                  ></ion-icon>
                </ng-container>
                <ng-container class="c-black" *ngIf="!element.incubatorRegDesc">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorStatusUpdatedDate">
              <th mat-header-cell *matHeaderCellDef>Rejected Date</th>
              <td mat-cell *matCellDef="let element">
                {{ element.incubatorStatusUpdatedDate }}
              </td>
            </ng-container>
            <ng-container matColumnDef="reason">
              <th mat-header-cell *matHeaderCellDef>Reason</th>

              <td mat-cell *matCellDef="let element" class="text-center c-blue">
                <ng-container *ngIf="element.reason">
                  <ion-icon
                    name="eye-outline"
                    (click)="viewDescrptionBtn(element.reason, 'View Reason')"
                  ></ion-icon>
                </ng-container>
                <ng-container class="c-black" *ngIf="!element.reason">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegistrationType">
              <th mat-header-cell *matHeaderCellDef>Registration Type</th>
              <td mat-cell *matCellDef="let element" class="center-cell">
                <span
                  >{{
                    element.incubatorRegistrationType
                      ? element.incubatorRegistrationType
                      : "-"
                  }}
                </span>
                <span *ngIf="element.incubatorRegistrationType === 'Other'"
                  >- {{ element.incubatorRegistrationTypeOther }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="incubatorRegFileName">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                View Document
              </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <ng-container *ngIf="element.incubatorRegFileName">
                  <a href="{{ element.incubatorRegFileName }}" target="_blank">
                    <ion-icon name="document-attach-outline"></ion-icon>
                  </a>
                </ng-container>
                <ng-container *ngIf="!element.incubatorRegFileName">
                  <span>-</span>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th class="text-center" mat-header-cell *matHeaderCellDef>
                Action
              </th>
              <td class="text-center" mat-cell *matCellDef="let element">
                <button
                  class="approval-span"
                  (click)="pendingModalOpen(element.incubatorUserId)"
                >
                  Move to Pending
                </button>
                <button
                  class="approval-spans"
                  (click)="modalOpen(element.incubatorUserId)"
                >
                  Approve
                </button>
              </td>
            </ng-container>
          </table>
        </div>
        <mat-paginator
          #paginator
          class="mat-elevation-z8"
          [length]="pageTotalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[25, 50, 75, 100]"
          showFirstLastButtons
          (page)="getServerData($event)"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>There are no rejected incubators</h6>
      </div>
    </div>
  </div>
</div>
<!-- modal -->
<div id="editModals" class="modal">
  <div class="modal-content text-center">
    <div class="text-center">
      <img
        class="image-sec"
        style="width: 100px"
        src="/assets/images/attention -man.gif"
        alt=""
      />
    </div>

    <h4 style="font-size: 20px; font-weight: 500">
      Are you sure to continue ?
    </h4>

    <div class="text-center mt-2">
      <button class="incubatorBtn" (click)="closeModal()">No</button>
      <button class="successBtn ml-2" (click)="saveModal()">Yes</button>
    </div>
  </div>
</div>
<!-- Pending Modal -->
<div id="PendingModals" class="modal">
  <div class="modal-content text-center">
    <div class="text-center">
      <img
        class="image-sec"
        style="width: 100px"
        src="/assets/images/attention -man.gif"
        alt=""
      />
    </div>

    <h4 style="font-size: 20px; font-weight: 500">
      Are you sure to continue ?
    </h4>

    <div class="text-center mt-2">
      <button class="incubatorBtn" (click)="pendingCloseModal()">No</button>
      <button class="successBtn ml-2" (click)="pendingSaveModal()">Yes</button>
    </div>
  </div>
</div>
